module.exports = __webpack_public_path__ + "static/media/360_tour.e22e01ae.svg";